<!--
  @Description: 药品详情
  @Author: wang.y 
  @Date: 2023-08-17 
-->
<template>
  <div class="container">
    <div class="title">{{detail.title}}</div>
    <div class="content" v-html="detail.content"></div>
  </div>
</template>
<script>
import { getElderlyDetail } from '@/service'
export default {
  components: {},
  created() {
    this.getElderlyDetail()
  },
  mounted() {},
  data() {
    return {
      detail: {},
    }
  },
  computed: {},
  methods: {
    async getElderlyDetail() {
      let res = await getElderlyDetail({
        id: this.$route.params.id,
      })
      if (res.status == 'success') {
        if (res.res.length == 0) {
          this.$Message.error('暂无数据')
          return
        }
        this.$set(this.$data, 'detail', res.res[0])
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
.container
  margin 40px auto
  color #333
  .title
    width 820px
    font-size 20px
    font-weight bold
    line-height 28px
    margin 0 auto 20px
  .content
    margin 0 auto
    width 820px
    background #fff
    box-shadow 0 15px 30px rgba(0, 0, 0, 0.1)
    padding 30px
    >>> table
      width 100%
    >>> img
      max-width 100% !important
    >>> .specificationBox
      th
        width 100px
        text-align left
</style>